import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@hopskipdrive/react-components';

import { DuplicateLocationModal } from './DuplicateLocationModal';

export const DuplicationLocation: FC = () => {
  const { locationId } = useParams() as { locationId: string };

  if (locationId) {
    return null;
  }

  return (
    <Box>
      <DuplicateLocationModal />
    </Box>
  );
};
